import { API } from "../../../utils";

export const getUbereatsList = async () => {
  const res = await API.get(`ubereats/stores`);
  return res.data;
};
export const uploadAllMenu = async (intID) => {
  const res = await API.get(`integrations/${intID}/menu_upload`);
  return res;
};
export const uploadPushMenu = async (intID, id) => {
  const res = await API.get(`integrations/${intID}/stores/${id}/menu_upload`);
  return res;
};
export const editUbereats = async (payload) => {
  const res = await API.put(`ubereats/stores`, payload);
  return res.data;
};

export const getUberEatsConnectionApi = async () => {
  const res = await API.get(`uber-eats/connection`);
  return res.data;
};
export const authorizeUberEatsApi = async (payload) => {
  const res = await API.post(`uber-eats/oauth/authorize`, payload);
  return res.data;
};
export const getUberEatsStoresApi = async () => {
  const res = await API.get(`uber-eats/stores`);
  return res.data;
};
export const activateUberEatsStoreApi = async (payload) => {
  const res = await API.post(`uber-eats/stores/activate`, payload);
  return res.data;
};
export const deactivateUberEatsStoreApi = async (storeID) => {
  const res = await API.delete(`uber-eats/stores/${storeID}`);
  return res.data;
};



